<template>
  <div>
    <div class="not-print">
      <div class="not-print"></div>
      <button class="btn btn-primary" style="margin: 15px" @click="print">
        Imprimir
      </button>
      <button class="btn btn-primary" style="margin: 15px" @click="printCupom">
        Cupom
      </button>
      <br />
    </div>

    <div class="page" size="A4" v-for="page in pages" :key="'page' + page">
      <table>
        <pr-row>
          <pr-col colspan="2">
            <b>{{ company.name }}</b>
          </pr-col>
          <pr-col class="text-right">
            <!-- <img
              src="https://casasdastintas.com.br/wp-content/uploads/2018/07/Logo-Oficial-Cadas-das-Tintas-222-x-62.svg"
              border="0"
            />-->
          </pr-col>
        </pr-row>
        <pr-row>
          <pr-col class="text-left">{{ company.cnpj | cnpj }}</pr-col>
        </pr-row>
        <pr-row>
          <pr-col class="text-left"
            >{{ addressCompany.address }}, {{ addressCompany.number }} /
            {{ addressCompany.city }}-{{ addressCompany.state }} -
            {{ company.phone_wa | phone }}</pr-col
          >
        </pr-row>
      </table>
      <hr />

      <!-- INDENTIFICADOR CLIENTE E VENDA -->
      <table style="width: 100%">
        <template v-if="person.id != null">
          <pr-row>
            <pr-col colspan="2">
              <b>
                <h5>
                  <i class="fas fa-user" />
                  {{ person.name }}
                </h5>
              </b>
            </pr-col>
            <pr-col colspan="1" class="text-right">
              <b>
                <h5>
                  <i class="fas fa-shopping-cart" />
                  {{ getDescription(order.status) }} #{{ order.number }}
                </h5>
              </b>
            </pr-col>
          </pr-row>
          <pr-row>
            <pr-col colspan="2">
              <i class="fas fa-map-marked-alt" />
              {{ person_address.address }}, {{ person_address.number }} -
              {{ person_address.district }} / {{ person_address.city }}-{{
                person_address.state
              }}
            </pr-col>
            <pr-col colspan="1" class="text-right">
              <i class="fas fa-calendar-alt" />
              {{ order.ordered_at | dateTimeBr }}
            </pr-col>
          </pr-row>
          <pr-row>
            <pr-col colspan="2">
              <i class="fas fa-phone" />
              {{ person.phone_wa | phone }}
            </pr-col>
            <!-- <pr-col class="text-right">
             <i class="fas fa-user"/>
          Matheus
          </pr-col>-->
          </pr-row>
          <pr-row>
            <pr-col>
              <i class="fas fa-envelope" />
              {{ person.email1 }}
            </pr-col>
          </pr-row>
        </template>

        <template v-else>
          <pr-row>
            <pr-col colspan="2">
              <b>
                <h5>
                  <i class="fas fa-user" />
                  Consumidor Final
                </h5>
              </b>
            </pr-col>
            <pr-col colspan="1" class="text-right">
              <b>
                <h5>
                  <i class="fas fa-shopping-cart" />
                  {{ getDescription(order.status) }} #{{ order.number }}
                </h5>
              </b>
            </pr-col>
          </pr-row>
          <pr-row>
            <pr-col colspan="2">
              <!-- <i class="fas fa-map-marked-alt" /> -->
              <!-- {{person_address.address}}, {{person_address.number}} - {{person_address.district}} / {{person_address.city}}-{{person_address.state}} -->
            </pr-col>
            <pr-col colspan="1" class="text-right">
              <i class="fas fa-calendar-alt" />
              {{ order.ordered_at | dateTimeBr }}
            </pr-col>
          </pr-row>
          <pr-row>
            <!-- <pr-col class="text-right">
             <i class="fas fa-user"/>
          Matheus
          </pr-col>-->
          </pr-row>
        </template>
      </table>
      <br />
      <!-- INDENTIFICADOR CLIENTE E VENDA -->

      <table class="table table-sm">
        <pr-row>
          <pr-col class="text-left">Código</pr-col>
          <pr-col class="text-left">Descrição</pr-col>
          <pr-col class="text-right">Quantidade</pr-col>
          <pr-col class="text-right">Valor</pr-col>
          <pr-col class="text-right">Total</pr-col>
        </pr-row>

        <!-- table itens -->
        <template style="width: 100%">
          <pr-row
            v-for="item in printConfig.itensPerPage"
            :key="'item' + item + '/' + page"
          >
            <template v-if="hasItemOnIndex(page, item)">
              <pr-col class="text-left">{{
                orderProducts[getIndex(page, item)].base_sku_id
              }}</pr-col>
              <pr-col class="text-left">{{
                orderProducts[getIndex(page, item)].product
              }}</pr-col>
              <pr-col class="text-right">{{
                orderProducts[getIndex(page, item)].quantity | decimal
              }}</pr-col>
              <pr-col class="text-right">{{
                orderProducts[getIndex(page, item)].price | decimal
              }}</pr-col>
              <pr-col class="text-right">
                {{
                  (orderProducts[getIndex(page, item)].quantity *
                    orderProducts[getIndex(page, item)].price)
                    | decimal
                }}
              </pr-col>
            </template>
            <template v-else>
              <pr-col style="border: none">&nbsp;</pr-col>
            </template>
          </pr-row>
        </template>
      </table>
      <hr class="color" />
      <!-- table itens -->
      <pr-col v-for="orderBill in orderBills" :key="orderBill.id">
        <payment-method-badge
          class="mr-2"
          :paymentMethod="orderBill.payment_method"
        />
        <small
          >{{ orderBill.value | decimal }} -
          {{ orderBill.due_date | dateBr }}</small
        >
      </pr-col>
      <br />

      <table style="width: 100%">
        <pr-col width="80">
          <b>Observação:</b>
          <template v-if="order.status == 'p'">
            Orçamento Valido por 7 dias
          </template>
          <template v-if="order.notes">
            {{ order.notes }}
          </template>
        </pr-col>
        <pr-col class="text-right" width="10">
          <pr-row>
            <pr-col width="50">Sub-Total:</pr-col>
            <pr-col class="text-right" width="50">{{
              order.product_total | decimal
            }}</pr-col>
          </pr-row>
          <pr-row class="text-right">
            <pr-col width="50">Desconto:</pr-col>
            <pr-col class="text-right" width="50">{{
              order.discount | decimal
            }}</pr-col>
          </pr-row>
          <pr-row class="text-right">
            <pr-col width="50">Total:</pr-col>
            <pr-col class="text-right" width="50">{{
              order.net_total | decimal
            }}</pr-col>
          </pr-row>
        </pr-col>
      </table>
    </div>

    <!-- bills  -->
    <div
      class="page"
      v-for="(billPage, index) in billPages"
      :key="'billPage' + index"
    >
      <template v-for="billPerPageIndex in printConfig.billsPerPage">
        <template v-if="hasBill(billPage, billPerPageIndex)">
          <bill-promissory
            class="mb-3"
            :bill="bills[getBillIndex(billPage, billPerPageIndex)]"
            :company="company"
            :addressCompany="addressCompany"
            :person="person"
            :personaddress="person_address"
            :key="billPerPageIndex"
          />
        </template>
      </template>
    </div>
    <!-- bills  -->
  </div>
</template>

<script>
import PrRow from "./../../components/printers/grid/PrRow";
import PrCol from "./../../components/printers/grid/PrCol";
import Filters from "./../../mixins/Filters";
import BillPromissory from "./../../components/printers/BillPromissory.vue";
import PaymentMethodBadge from "../../components/account/sections/PaymentMethodBadge.vue";

export default {
  components: { PrRow, PrCol, BillPromissory, PaymentMethodBadge },

  data: function () {
    return {
      order: {},

      orderBills: {},

      orderProducts: [],

      person: {},

      person_address: [],

      company: {},

      bills: [],

      addressCompany: {},

      printConfig: {
        itensPerPage: 10,
        billsPerPage: 2,
      },

      payment_method: {
        1: {
          text: "Dinheiro",
          class: "badge-success",
          value: "0",
        },

        2: {
          text: "Cheque",
          class: "badge-secondary",
        },

        5: {
          text: "Crédito Loja",
          class: "badge-info",
        },

        15: {
          text: "Boleto Bancário",
          class: "badge-secondary",
        },
        16: {
          text: "Depósito Bancário",
          class: "badge-secondary",
        },
        17: {
          text: "PIX",
          class: "badge-secondary",
        },

        18: {
          text: "Carteira Digital ",
          class: "badge-secondary",
        },
        99: {
          text: "Outros ",
          class: "badge-secondary",
        },
      },
    };
  },

  mounted() {
    this.$store.commit("pageHasLoaded");
  },

  created() {
    if (this.$route.params.id) {
      axios
        .post("../../../api/order/edit/" + this.$route.params.id)
        .then((response) => {
          this.order = response.data.order;
          this.orderBills = response.data.orderBills;
          this.orderProducts = response.data.orderProducts;
          this.person = response.data.person;
          this.person_address = response.data.address;
          this.company = response.data.company;
          this.bills = response.data.bills;
          this.addressCompany = response.data.addressCompany;

          this.$store.commit("pageHasLoaded");
        })
        .catch((error) => {
          this.error = error;
        });
    } else {
      this.$store.commit("pageHasLoaded");
    }
  },

  computed: {
    itensCount() {
      if (this.orderProducts) {
        return this.orderProducts.length;
      }
      return 1;
    },

    pages() {
      return Math.ceil(this.itensCount / this.printConfig.itensPerPage);
    },

    billsCount() {
      if (this.bills) {
        return this.bills.length;
      }
      return 1;
    },

    billPages() {
      return Math.ceil(this.billsCount / this.printConfig.billsPerPage);
    },
  },

  methods: {
    print() {
      window.print();
    },

    getIndex(page, item) {
      return (page - 1) * this.printConfig.itensPerPage + item - 1;
    },

    hasItemOnIndex(page, item) {
      return this.getIndex(page, item) < this.orderProducts.length;
    },

    getBillIndex(page, billPerPageIndex) {
      return (page - 1) * this.printConfig.billsPerPage + billPerPageIndex - 1;
    },

    hasBill(page, billPerPageIndex) {
      return this.getBillIndex(page, billPerPageIndex) < this.bills.length;
    },

    printCupom(order) {
      window.open("/vendas/imprimir/cupom/" + this.order.id, "_blank");
    },
    getDescription(orderType) {
      if (orderType == "d") {
        return "Rascunho";
      }

      if (orderType == "p") {
        return "Orçamento";
      }
      if (orderType == "o") {
        return "Venda de Mercadorias";
      }
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: avoid;
    page-break-before: always;
    page-break-inside: avoid;
  }

  .not-print {
    display: none;
  }
}
hr.color {
  border: 1px solid black;
}
</style>
